"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("./global");
var Sorting = /** @class */ (function () {
    /**
     * 建構排序設定
     * @param column 欄位
     * @param order 順序
     */
    function Sorting(column, order) {
        if (order === void 0) { order = global_1.SortOrder.Ascending; }
        /** 順序 */
        this.order = global_1.SortOrder.Ascending;
        this.column = column;
        this.order = order || global_1.SortOrder.Ascending;
    }
    return Sorting;
}());
exports.default = Sorting;
